import { type FormHTMLAttributes, forwardRef } from "react";
import { cn } from "./utils/cn";

export type FormProps = FormHTMLAttributes<HTMLFormElement>;

export const Form = forwardRef<HTMLFormElement, FormProps>(
  ({ noValidate = true, className, children, ...rest }, ref) => (
    <form ref={ref} noValidate={noValidate} className={cn("hui-form", className)} {...rest}>
      {children}
    </form>
  )
);

Form.displayName = "Form";
